export const getCurrentSelection = ({ inPage, }) => {
    return inPage ? window.getSelection()?.toString() : undefined;
};
//# sourceMappingURL=clientContext.js.map